var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('users-filters')],1),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('user-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }